module.exports = __webpack_public_path__ + "img/612685230ff8fb8898837aac_image-cta-app-x-template-p-500.cce12ca0.png";